import { useTrackerUser } from "components/AuthProvider";
import { UserWithCompany } from "lib/frontend/cm/utils/types";
import { Company } from "prisma/cm/client";

import { BENCHMARK_DATASET } from "../constants/enums";

export function useAuthorizedDataSets(defaultUser?: UserWithCompany) {
  let user = useTrackerUser();
  if (!user && defaultUser) {
    user = defaultUser;
  }

  const datasets: Record<BENCHMARK_DATASET, boolean> = {
    comprehensive: false,
    comptryx: false,
    mercer: false,
    carta: false,
    salary: false,
  };

  if (!user || user.role !== "COMPANY_ADMIN") {
    return datasets;
  }

  datasets.comprehensive = true;

  const company = user.company as Company;

  if (company.enableAdminComptryxBenchmarking) {
    datasets.comptryx = true;
  }

  if (company.enableAdminMercerBenchmarking) {
    datasets.mercer = true;
  }

  if (company.enableSalaryComBenchmarking) {
    datasets.salary = true;
  }

  // if (
  //   integrations?.some((integration) => {
  //     return integration.provider === IntegrationProvider.CARTA_BENCHMARK;
  //   })
  // ) {
  //   datasets.carta = true;
  // }

  return datasets;
}
